import { Alert, Box, Col, Row } from "@intech/web-ui";
import React from "react";
import { ComboData, ComboSimulador } from "../ComboSimulador";
import { WrapRow, GrayBox, BoxTitle } from "./styles";

interface Props {
  titulo: string | React.ReactNode;
  TextoAlert?: string;
  TextoAlertAlt?: string;
  dados: Array<ComboData>;
  comboLabel: string;
  onChange: (selectedOption: any) => void;
  valorInicial?: string;
}

export const BoxInfoSimulador: React.FC<Props> = ({
  titulo,
  TextoAlert,
  TextoAlertAlt,
  dados,
  comboLabel,
  onChange,
  valorInicial
}) => {

  return (
    <Row>
      <Col>
        <Box title={typeof titulo === "string" ? titulo : ""}>
          {typeof titulo !== "string" && <BoxTitle>
            {titulo}
          </BoxTitle>}

          <Alert type={"info"}>
            {TextoAlert}
          </Alert>

          <ComboSimulador
            dados={dados}
            label={comboLabel}
            onChange={onChange}
            valorInicial={valorInicial}
          />

          {TextoAlertAlt && <Alert type={"warning"}>
            {TextoAlertAlt}
          </Alert>}
        </Box>
      </Col>
    </Row>
  );
}